var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center flex-column",staticStyle:{"height":"300px"}},[_c('div',{staticClass:"mb-10 text-h3 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('waitAMoment'))+" ")]),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }